import React from 'react'
import { ManufacturerMidTab } from './manufacturer-mid/ManufacturerMidTab'

export const tabs = [
  { label: 'Manufacturer (MID)', component: <ManufacturerMidTab /> }
]
